import React from 'react';
import loaderStyles from './loader.css';

const Loader = () => (
	<div className={loaderStyles.loader}>
		<span className={loaderStyles.circle + ' ' + loaderStyles.circle1} />
		<span className={loaderStyles.circle + ' ' + loaderStyles.circle2} />
		<span className={loaderStyles.circle + ' ' + loaderStyles.circle3} />
	</div>

);
export default Loader;
